import React from 'react';
import type { Equipo } from '../types';
import { PageShell, glassLight, primaryButton, ghostButton, dangerButton, Badge, EmptyState, MotionGrid, MotionItem, T } from '../ui';
function estadoColor(estado: string) {
  const e = estado.toLowerCase();
  if (e.includes('disponible')) return {
    color: T.ok,
    soft: T.okSoft
  };
  if (e.includes('uso')) return {
    color: T.info,
    soft: T.infoSoft
  };
  if (e.includes('mantenimiento')) return {
    color: T.warn,
    soft: T.warnSoft
  };
  return {
    color: T.textMuted,
    soft: 'rgba(255,255,255,0.06)'
  };
}
export function Equipos({
  equipos,
  onNew,
  onEdit,
  onDelete
}: {
  equipos: Equipo[];
  onNew: () => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}) {
  return <PageShell title="Equipos" sub="Luxómetros, calibración y herramientas" action={<button onClick={onNew} style={primaryButton} data-id="element-542">
          + Nuevo equipo
        </button>} data-id="element-541">
      {equipos.length === 0 ? <EmptyState title="Sin equipos registrados" hint="Registra luxómetros y herramientas para llevar control de calibración." icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" data-id="element-544">
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" data-id="element-545" />
            </svg>} data-id="element-543" /> : <MotionGrid style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))',
      gap: 14
    }} data-id="element-546">
          {equipos.map(e => {
        const ec = estadoColor(e.estado);
        return <MotionItem key={e.id} className="getr-card" style={{
          ...glassLight,
          padding: 20
        }} data-id="element-547">
                <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 12
          }} data-id="element-548">
                  <div style={{
              minWidth: 0
            }} data-id="element-549">
                    <div style={{
                fontSize: 15,
                fontWeight: 700,
                color: T.text
              }} data-id="element-550">
                      {e.nombre}
                    </div>
                    <div style={{
                color: T.textMuted,
                fontSize: 12,
                marginTop: 5
              }} data-id="element-551">
                      Serial {e.serial || 'sin serial'}
                    </div>
                  </div>
                  <div style={{
              display: 'flex',
              gap: 8,
              flexShrink: 0
            }} data-id="element-552">
                    <button className="getr-btn-ghost" onClick={() => onEdit(e.id)} style={ghostButton} data-id="element-553">
                      Editar
                    </button>
                    <button onClick={() => onDelete(e.id)} style={dangerButton} data-id="element-554">
                      Eliminar
                    </button>
                  </div>
                </div>
                <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 18,
            paddingTop: 14,
            borderTop: `1px solid ${T.border}`
          }} data-id="element-555">
                  <Badge label={e.estado} color={ec.color} soft={ec.soft} data-id="element-556" />
                  <span style={{
              color: T.textSecondary,
              fontSize: 12
            }} data-id="element-557">
                    Calib. {e.calibracion}
                  </span>
                </div>
              </MotionItem>;
      })}
        </MotionGrid>}
    </PageShell>;
}